import PAID_LEAVE from '../../constants'
import { stateAbv, stateName } from '../../../common/components/drawMap'

export const tooltipText = (dataSet, datum) => {
  const abv = stateAbv(datum)
  const data = dataSet.find((x) => x.stateAbv === abv) || {}
  const { products } = data
  let productList = ''

  let federalNote
  if (
    (products.paidFamilyMedicalLeave && products.paidFamilyMedicalLeave.hasTopics)
    || (products.paidSickLeave && products.paidSickLeave.hasTopics)
    || (products.paidLeave && products.paidLeave.hasTopics)
  ) {
    PAID_LEAVE.PRODUCTS.forEach(({ id, name }) => {
      if (products[id].hasTopics) {
        productList += `<li>${name}: ${products[id].count} locations</li>`
      }
    })
    federalNote = '* Federal laws may apply to additional locations'
  } else {
    productList += '<li>No applicable Paid Leave Types</li>'
    federalNote = `* Federal laws may apply to locations: ${data.stateLocationCount || 0} Locations`
  }

  return `
    <p style="margin-top: 0px;font-weight: 600;">
        ${stateName(datum)}
    </p>
    <ul>
        ${productList}
    </ul>
    <p style="margin-bottom: 0px">
        ${federalNote}
    </p>`
}
